import Box from "@mui/material/Box";
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import Typography from "@mui/material/Typography";

export default function DiscountRankingCard({  cpf, numberOfUses, ranking }) {
  return (
    <Box
      sx={{
        alignItems: "center",
        backgroundColor: "#F5F5F5",
        borderRadius: "30px",
        boxShadow: "0px 0px 10px 0px rgb(88 88 88 / 20%) inset",
        display: "flex",
        flexDirection: "column",
        height: "130px",
        justifyContent: "space-around",
        overflow: "hidden",
        textAlign: "center",
        width: "130px",
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "space-evenly",
          height: "60px",
          pt: 1,
          width: "100px"
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            backgroundColor: "#E8E8E8",
            borderRadius: "25px",
            boxShadow: "0px 0px 10px 0px rgb(88 88 88 / 10%) inset",
            display: "flex",
            height: "50px",
            justifyContent: "center",
            width: "50px"
          }}
        >
          <Typography
            variant="h4"
            component="p"
            color="golden"
            sx={{ userSelect: "none" }}
          >
            { ranking }º
          </Typography>
        </Box>
        <EmojiEventsIcon
          color={
            (ranking === 1 && "golden")
            || (ranking === 2 && "silver")
            || (ranking === 3 && "bronze")
            || ("primary")
          }
          fontSize="large"
        />
      </Box>
      <Box
        sx={{ 
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          mb: 1,
        }}
      >
        <Typography variant="caption" sx={{ userSelect: "none" }}>
          { !!cpf ? `${ cpf }` : 'CPF: -' }
        </Typography>
        {/* <Typography variant="caption" fontWeight={600} sx={{ userSelect: "none" }}>
        { `${numberOfUses} consultas!` }
        </Typography> */}
      </Box>
    </Box>
  );
};
